import React from 'react'
import { FormattedMessage } from 'react-intl'

import PingPongButton from './buttons-by-step/PingPongButton'
import { PingPongButtonTypeEnum } from './utils/ping-pong-button-type.enum.ts'
import {
  ClientProposalFragment,
  ClientProposalUserActionEnum,
} from '../../../../lib/graphql'

export const ProposalMiceCta = ({
  clientProposal,
}: {
  clientProposal: Pick<ClientProposalFragment, 'userCurrentAction'>
}) => {
  switch (clientProposal.userCurrentAction) {
    case ClientProposalUserActionEnum.BOOKING_DECLINED_BY_USER_ADMIN:
      return (
        <PingPongButton
          label={
            <FormattedMessage
              id='ui.ProposalMiceCta.userAdminDeclinedBooking'
              defaultMessage='Vous avez refusé ce séjour'
            />
          }
          type={PingPongButtonTypeEnum.DECLINED_BY_USER_ADMIN}
        />
      )
    case ClientProposalUserActionEnum.WAITING_HOST_QUOTATION:
      return (
        <PingPongButton
          label={
            <FormattedMessage
              id='ui.ProposalMiceCta.waitingHostAnswer'
              defaultMessage="Attente de réponse de l'hôte"
            />
          }
          type={PingPongButtonTypeEnum.WAITING}
        />
      )
  }
  return null
}
